module.exports = __webpack_public_path__ + "img/er.aa057175.png";